import React, { useState } from 'react';

import PropTypes from 'prop-types';
import Spinner from '@tds/core-spinner';

import request from '../../../utils/request';
import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import { Button } from './css';
import { DisabledAction } from '../css';
import ConfirmationBox from '../../../design/shared/ConfirmationBox';

const ReturnToSales = ({ orderData, fetchOrders }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { requestOrderReturnButtonLabel },
    srtDashboard: { confirmationDialog, orderResendAckMessage }
  } = localizedStrings;
  const { id, isOrderReturned } = orderData;

  const [isLoading, setIsLoading] = useState(false);
  const [acknowledgementMessage, setAcknowledgementMessage] = useState({
    message: '',
    isOpen: false
  });

  const handleOrderReturn = () => {
    const body = {
      status: 'Incomplete'
    };
    setIsLoading(true);
    request.put(`/orders/${id}`, body).then(() => {
      setIsLoading(false);
      setAcknowledgementMessage({
        message: orderResendAckMessage,
        isOpen: true
      });
    });
  };

  return (
    <>
      <Spinner
        fullScreen={isLoading}
        label="Requesting..."
        spinning={isLoading}
      />
      {acknowledgementMessage.isOpen && (
        <ConfirmationBox
          header={confirmationDialog}
          open={acknowledgementMessage.isOpen}
          setOpen={() => {
            setAcknowledgementMessage({ message: '', isOpen: false });
          }}
          onClose={() => {
            fetchOrders();
          }}
        >
          <p style={{ fontSize: '15px' }}>
            The request was sent back to the Sales rep successfully
          </p>
        </ConfirmationBox>
      )}
      {!isOrderReturned && (
        <Button onClick={handleOrderReturn}>
          {requestOrderReturnButtonLabel}
        </Button>
      )}
      {isOrderReturned && (
        <DisabledAction>{requestOrderReturnButtonLabel}</DisabledAction>
      )}
    </>
  );
};

ReturnToSales.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default ReturnToSales;
